import React from "react"

import Quote from "@atoms/Quote/Quote"

import styles from "./CoreQuote.module.scss"

const CoreQuote = ({ html, citation }) => {
  return html || citation !== "<p></p>" ? (
    <section className={styles.element}>
      <Quote html={html} citation={citation} />
    </section>
  ) : null
}

export default CoreQuote
